import React from 'react';
import { useDispatch } from 'react-redux';
import { fetchTimelineData } from '@store/timeline/data/actions';
import Timeline from '@components/session-timeline';

import TimelinePageStyled from './styled';
import { useParams } from 'react-router-dom';

interface TimelineProps {
  isSharing: boolean;
  pageType: number;
}

const TimelinePage = ({ pageType, isSharing = false }: TimelineProps) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(fetchTimelineData(pageType));
  }, [id, dispatch]);

  return (
    <TimelinePageStyled>
      <Timeline isSharing={isSharing} id={id} pageType={pageType} />
    </TimelinePageStyled>
  );
};

export default TimelinePage;
